export default "__VITE_ASSET__C24FOYuT__"